<template>
  <el-form
    :model="form"
    ref="form"
    :disabled="disabledForm"
  >
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('rfqid')"
          prop="rfqid"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.rfqid"
            @input="form.rfqid = valueTrimLeft($event)"
            @change="updateModelItem('rfqid', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('supplier-company')"
          :rules="getValidationRule('required')"
          prop="supplierCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.supplierCompanyID"
            @update:model="updateModelItem('supplierCompanyID', { required: true })"
            :disabled="disabledForm"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('employee')"
          prop="employeeID"
          :rules="rulesEmployee"
          class="material-style">
          <select-response
            :model.sync="form.employeeID"
            @update:model="updateModelItem('employeeID', { required: true })"
            :disabled="disabledEmployee"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.isLoading"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4 col-8">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.conditionID"
            @update:model="updateModelItem('conditionID', { required: true })"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-4">
        <el-form-item
          :label="L10n('qty')"
          prop="qty"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.qty"
            @input="form.qty = valueInteger($event)"
            @change="updateModelItem('qty', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12 price-field">
        <el-form-item
          :label="L10n('price')"
          prop="price"
          class="price-field__field material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.price"
            @input="form.price = valueNumber($event)"
            @change="updateModelItem('price', { required: false })"
          />
        </el-form-item>
        <el-form-item
          prop="currencyID"
          :label="L10n('currency')"
          class="price-field__value material-style"
        >
          <select-response
            :model.sync="form.currencyID"
            @update:model="updateModelItem('currencyID', { required: false })"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-form-item
          :label="L10n('remark')"
          prop="stockRemark"
          class="material-style"
        >
          <el-input
            v-model="form.remarks"
            @change="updateModelItem('remarks', { required: false })"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormSupplierQuotes',
  mixins: [Form],
  components: {
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  props: {
    hasCreateNew: { type: Boolean, required: true }
  },
  computed: {
    rulesEmployee () {
      if (this.hasCreateNew) {
        return []
      } else {
        return this.getValidationRule('requiredSelect')
      }
    },
    disabledEmployee () {
      return !this.$store.getters.isHighPermission
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    }
  }
}
</script>
